export default __webpack_public_path__ + "6c940c85970701abd82ae610ae44cfdd.jpg";